export default {
  //API_ENDPOINT: 'http://localhost:8000/api',
  //CALC_ENGINE_ENDPOINT: 'http://localhost:8000/api/riskbudget',
  CALC_ENGINE_ENDPOINT: 'https://mighty-reef-59398.herokuapp.com/api/riskbudget',
  API_ENDPOINT: 'https://damp-beach-84980.herokuapp.com/api',
  TOKEN_KEY: 'risk-budget-client-auth-token',
}